export const DEFAULT_LANGUAGE = "en"
export const LOCALE_COOKIE_NAME = "lng"

/**
 * Languages with documentation translations available.
 * This is a subset of SUPPORTED_LANGUAGES.
 */
export const DOCS_LANGUAGES = ["en"] as const

export const SUPPORTED_LANGUAGES = ["en"]
